import React from 'react';
import { Form, Input, Button,Select,Spin } from 'antd';
import axios from 'axios'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import * as serverconfig from '../../views/serverconn'
import { SearchOutlined,LoadingOutlined,DeleteOutlined,FundViewOutlined,WalletFilled,EditOutlined } from '@ant-design/icons';

const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''


class CompanyProfileForm extends React.Component {

  state = {
    companyname:'' ,  
    branchname:'',
    companyemail:'',
    companylogo:null,   
    companyphone:'',
    boxnumber:'',
    datarequested:false,  

  }

  componentDidMount(){
    if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

  }



  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('company_logo', this.state.companylogo, this.state.companylogo.name);
    form_data.append('company_name', this.state.companyname);
    form_data.append('branch_name', this.state.branchname);
    form_data.append('company_email', this.state.companyemail);
    form_data.append('RegisteredPhoneNumber1', this.state.companyphone);
    form_data.append('box_number', this.state.boxnumber);
   
      axios.post(serverconfig.backendserverurl+'/api/companyprofile/', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => this.setState({datarequested:false}),
    window.location.reload(false)
    )
    .catch(error => console.log(error))


    


  }

  handleCompanyNameChange= (e) => this.setState({ companyname: e.target.value});
  handleBranchNameChange= (e) => this.setState({ branchname: e.target.value});
  handleCompanyEmailChange= (e) => this.setState({ companyemail: e.target.value});
  handleCompanyLogoChange= (e) => this.setState({ companylogo: e.target.files[0]});

  handleCompanyPhoneChange= (e) => this.setState({ companyphone: e});
  handleCompanyBoxNumberChange= (e) => this.setState({ boxnumber: e.target.value});


  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{

      return (
        <div>
          <Form
          onFinish={(event) => this.handleFormSubmit(event)}
          >
            <FormItem label="Company Name"
                name="companyname"
                rules={[
                  {
                    required: true,
                    message: 'Please input name',
                  },
                ]}
              >
              <Input name="companyname"  placeholder="Put a name here." value={this.state.companyname} onChange={this.handleCompanyNameChange} />
            </FormItem>
            <FormItem label="Branch name"
                  name="branchname"
                  rules={[
                    {
                      required: true,
                      message: 'Please input branch name',
                    },
                  ]}
            >
              <Input name="branchname"  placeholder="Branch name here" value={this.state.branchname} onChange={this.handleBranchNameChange} />
            </FormItem>
            <FormItem label="Company Logo">
              <Input name="companylogo" type="file" accept="image/png, image/jpeg" placeholder="Company logo"  onChange={this.handleCompanyLogoChange}/>
            </FormItem>  
            <FormItem label="Company Email"
                name="companyemail"
                rules={[
                  {
                    required: true,
                    message: 'Please input email',
                  },
                ]}
            >
              <Input name="companyemail" type="email"  placeholder="company@email.com" value={this.state.companyemail} onChange={this.handleCompanyEmailChange} />
            </FormItem> 
  
            <FormItem label="Phone Number"
                name="companynumber"
                rules={[
                  {
                    required: true,
                    message: 'Please input tel contact',
                  },
                ]}          
            >
            <PhoneInput
                  countrySelectProps={{ unicodeFlags: true }}
                  defaultCountry="UG"
                  placeholder="Enter phone number"
                  value={this.state.companyphone} onChange={this.handleCompanyPhoneChange}/>
             </FormItem> 
  
            <FormItem label="Box number">
              <Input name="boxnumber"  placeholder="Box number here" value={this.state.boxnumber} onChange={this.handleCompanyBoxNumberChange} />
            </FormItem>
  
            <FormItem>
              <Button type="primary" htmlType="submit" >Create</Button>
            </FormItem>
          </Form>
        </div>
      );
    }

  
  }

}


export default CompanyProfileForm;



